/* HTML EXAMPLE:
  <div data-controller="lazy-load"
     data-lazy-load-url-value="/path/to/partial">
    <div data-lazy-load-target="output">
      <!-- Partial content will be loaded here -->
    </div>
  </div>
*/

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['output', 'loading']
  static values = {
    url: String,
    auto: { type: Boolean, default: true }
  }

  connect() {
    if (this.autoValue) this.loadPartial()
  }

  // For auto-value="false": trigger via data-action="lazy-load#load" on a
  // button. Swaps in the optional <template data-lazy-load-target="loading">
  // while the request runs.
  load() {
    if (this.hasLoadingTarget) {
      this.outputTarget.innerHTML = this.loadingTarget.innerHTML
    }
    this.loadPartial()
  }

  loadPartial() {
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then((html) => (this.outputTarget.innerHTML = html))
      .catch((error) => {
        console.error('Error loading the partial:', error)
        this.outputTarget.innerHTML =
          '<p class="text-muted text-center py-4">Could not load this section. Refresh the page to try again.</p>'
      })
  }
}
